import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Models } from '../../models/global.models';

function createInitialState(): Models.PreferredTimeContactLeadForm {
  return <Models.PreferredTimeContactLeadForm>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'preferred-time-contact-lead-store' })
export class PreferredTimeContactLeadStore extends Store<Models.PreferredTimeContactLeadForm> {
  constructor() {
    super(createInitialState());
  }
}
